import React from 'react';

const url = process.env.DEV ? 'http://localhost:3333/api' : 'https://admin.leonesdistritob9.org/api';

const ImgBannerContainer = ({ children, img = '' }) => (
  <div className="banner-container">
    <div
      alt="banner"
      className="banner-img"
      style={{ backgroundImage: img.includes('static') ? `url(${img})` : `url(${url}/${img})` }}
    />

    {children}
  </div>
);

export { ImgBannerContainer };
